export default {
    init() {
        const wrap = document.querySelector('.communities-block');
        if (!wrap) {
            return;
        }
        const loadMoreWrap = wrap.querySelector('.communities-block__bottom');
        const loadMoreBtn = wrap.querySelector('.show-more-communities');
        const resultsWrap = wrap.querySelector('.communities-block__content');
        const labelDropdown = wrap.querySelector('.communities-block__filter-dropdown__label');
        const dropdownWrap = wrap.querySelector('.communities-block__filter-dropdown');
        const dropdownItems = wrap.querySelectorAll('.communities-block__filter-dropdown__list li');
        const spinnerWrap = wrap.querySelector('.spinner-wrap');

        const setLoadingState = (isLoading) => {
            if (wrap) {
                wrap.classList.toggle('__is-loading');
            }
        };

        const __ajax_filter = async (val = {}) => {
            setLoadingState(true);
            try {
                const response = await fetch(block_script.ajax_url, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                    },
                    body: new URLSearchParams({
                        action: 'ajax_filter_communities',
                        ...val,
                    }),
                });

                const data = await response.json();
                
                const { items, is_load_more, is_no_results, hide_load_more } = data;

                if (is_load_more) {
                    resultsWrap.insertAdjacentHTML('beforeend', items);
                } else {
                    resultsWrap.innerHTML = items;
                }
                resultsWrap.classList.toggle('__is-no-results', !!is_no_results);
                if (loadMoreWrap) {
                    loadMoreWrap.style.display = hide_load_more ? 'none' : '';
                }
            } catch (e) {
                console.log(e);
            } finally {
                setLoadingState(false);
            }
        };
        const __get_data = (isLoadmore = false) => ({
            query: wrap.dataset.query,
            cat: labelDropdown?.dataset.cat,
            paged: loadMoreWrap?.dataset.paged,
            isLoadmore,
        });
        dropdownItems.forEach((item) => {
            item.addEventListener('click', () => {
                const cat = item.dataset.value;
                const html = item.innerHTML;
                if (labelDropdown) {
                    labelDropdown.innerHTML = html;
                    labelDropdown.dataset.cat = cat;
                }
                if (loadMoreWrap) {
                    loadMoreWrap.dataset.paged = '1';
                }

                dropdownItems.forEach(item => item.classList.remove('active'));
                item.classList.add('active');
                
                __ajax_filter(__get_data(false));
            });
        });
        loadMoreBtn?.addEventListener('click', (e) => {
            e.preventDefault();
            const currentPaged = parseInt(loadMoreWrap?.dataset.paged || '1', 10);
            const nextPaged = currentPaged + 1;
            if (loadMoreWrap) {
                loadMoreWrap.dataset.paged = String(nextPaged);
            }
            __ajax_filter(__get_data(true));
        });
    }
}